/* eslint-disable */
// AWS Configuration - All values sourced from environment variables
// Make sure to set up your .env file with the required REACT_APP_* variables

const awsmobile = {
    // AWS Region Configuration
    "aws_project_region": process.env.REACT_APP_AWS_REGION,
    "aws_region": process.env.REACT_APP_AWS_REGION,
    "aws_cognito_region": process.env.REACT_APP_AWS_REGION,

    // AWS Cognito Identity Pool Configuration  
    "aws_cognito_identity_pool_id": process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
    "cognito_identity_pool_id": process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,

    // AWS User Pools Configuration
    "aws_user_pools_id": process.env.REACT_APP_AWS_USER_POOLS_ID,
    "cognito_user_pool_id": process.env.REACT_APP_AWS_USER_POOLS_ID,
    "aws_user_pools_web_client_id": process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,

    // OAuth Configuration (empty by default)
    "oauth": {},

    // AWS Cognito Username Attributes
    "aws_cognito_username_attributes": [
        process.env.REACT_APP_AWS_COGNITO_USERNAME_ATTRIBUTES || "EMAIL"
    ],

    // AWS Cognito Social Providers (empty by default)
    "aws_cognito_social_providers": [],

    // AWS Cognito Signup Attributes (empty by default)
    "aws_cognito_signup_attributes": [],

    // AWS Cognito MFA Configuration
    "aws_cognito_mfa_configuration": process.env.REACT_APP_AWS_COGNITO_MFA_CONFIGURATION || "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],

    // AWS Cognito Password Protection Settings
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": parseInt(process.env.REACT_APP_AWS_COGNITO_PASSWORD_MIN_LENGTH) || 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },

    // AWS Cognito Verification Mechanisms
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],

    // AWS S3 Configuration
    "aws_s3_bucket_name": process.env.REACT_APP_AWS_S3_BUCKET_NAME,

    // No AWS access keys here: anything in this file ships to every browser.
    // Calls that need AWS permissions go through the backend API instead.

    // DynamoDB Configuration
    "dynamodb_users_table": process.env.REACT_APP_DYNAMODB_USERS_TABLE
};


export default awsmobile;
